export const lettersAndNumberMatch = /^[A-Za-z0-9 ]*$/;

export const onlyLettersAndNumbersAndSpaces = (str) => {
  return lettersAndNumberMatch.test(str);
}

export const checkStringLength = (min = 0, max = Infinity, { length }) => {
  return length >= min && length <= max;
}
